import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Leadership Assessment',
    path: '/leadership-capabilities',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'leadership-assessment',
      breadcrumb: {
        label: 'core.menu.modules.leadership-capabilities',
        route: 'leadership-assessment',
      },
    },
    children: [
      {
        name: 'Leadership Assessment Admin',
        path: '/leadership-capabilities/leadership-assessment',
        meta: {
          allowedRoles: [...allowed.leadership_assessment.roles],
          breadcrumb: {
            label: 'core.menu.modules.leadership-assessment',
            route: 'leadership-assessment-home',
          },
        },
        component: () =>
          import('@/modules/leadership-assessment/containers/leadership-assessment.container.vue'),
        children: [
          {
            path: '',
            name: 'leadership-assessment-home',
            component: () =>
              import('@/modules/leadership-assessment/components/leadership-assessment-home/leadership-assessment-home.vue'),
          },
          {
            name: 'leadership-assessment-create-survey',
            path: 'create/:id?',
            allowedRoles: [...allowed.leadership_assessment.roles],
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.home.createSurvey',
                route: 'leadership-assessment-create-survey',
              },
            },
            component: () =>
              import('@/modules/leadership-assessment/containers/create-survey.container.vue'),
          },
          {
            name: 'leadership-assessment-edit-survey',
            path: 'surveys/:id/edit/:mode?',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () => import('@/modules/leadership-assessment/containers/edit-survey.container.vue'),
            children: [
              {
                name: 'leadership-assessment-edit-survey-details',
                path: '',
                component: () => import('@/modules/leadership-assessment/components/project-setup/survey-details.vue'),
              },
              {
                name: 'leadership-assessment-edit-survey-add-participants',
                path: 'add-participants',
                component: () => import('@/modules/leadership-assessment/components/project-setup/add-participants.vue'),
              },
              {
                name: 'leadership-assessment-edit-survey-review-participants',
                path: 'review-participants',
                component: () => import('@/modules/leadership-assessment/components/project-setup/review-participants.vue'),
              },
              {
                name: 'leadership-assessment-edit-survey-select-competencies',
                path: 'competencies',
                component: () => import('@/modules/leadership-assessment/components/project-setup/select-competencies.vue'),
              },
              {
                name: 'leadership-assessment-edit-survey-preview-send',
                path: 'preview',
                component: () => import('@/modules/leadership-assessment/components/project-setup/preview-send.vue'),
              },
            ],
          },
          {
            name: 'leadership-assessment-review-survey',
            path: 'surveys/:id/review/:task',
            allowedRoles: [...allowed.leadership_assessment.roles],
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.approveSurvey.title',
                route: 'leadership-assessment-review-survey',
              },
            },
            component: () =>
              import('@/modules/leadership-assessment/containers/approve-survey.container.vue'),
          },
          {
            path: 'survey/:id',
            name: 'LeadershipAssessmentSurveyDetails',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () => import('@/modules/leadership-assessment/containers/survey-details.container.vue'),
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.surveyDetails.surveyDetails',
                route: 'LeadershipAssessmentSurveyDetails',
              },
            },
          },
          {
            path: 'survey/:id/organizational-report',
            name: 'leadership-assessment-organizational-report',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () =>
              import('@/modules/leadership-assessment/components/organizational-report/competencies-report.vue'),
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.organizationalReport.title',
                route: 'leadership-assessment-organizational-report',
              },
            },
          },
          {
            path: 'survey/:id/self-report/:participantId?',
            name: 'LeadershipAssessmentSelfReport',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () => import('@/modules/leadership-assessment/containers/self-report.container.vue'),
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.self-report.title',
                route: 'LeadershipAssessmentSelfReport',
              },
            },
          },
          {
            path: 'survey/:surveyId/participant/:participantId',
            name: 'LeadershipAssessmentParticipantDetails',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () => import('@/modules/leadership-assessment/containers/participant-details.container.vue'),
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.participantDetails.title',
                route: 'LeadershipAssessmentParticipantDetails',
              },
            },
          },
          {
            path: 'reports/:id?',
            name: 'LeadershipAssessmentReports',
            allowedRoles: [...allowed.leadership_assessment.roles],
            component: () => import('@/modules/leadership-assessment/containers/reports.container.vue'),
            meta: {
              breadcrumb: {
                label: 'leadership-assessment.reports.title',
                route: 'LeadershipAssessmentReports',
              },
            },
          },
        ],
      },
    ],
  },
]

export default index
